import { __read } from 'tslib';
import { useState } from 'react';
import { Form } from 'ssc-ui-react';
import useDidMount from '../useDidMount/index.js';

var useForm = function (defaultValue) {
    var _a = __read(Form.useForm(), 1), form = _a[0];
    var _b = __read(useState(false), 2), hasNull = _b[0], setHasNull = _b[1];
    var setNull = function (data) {
        setHasNull(Object.values(Object.assign(form.getFieldsValue(), data)).filter(function (v) { return !v || String(v).trim().length === 0; })
            .length > 0);
    };
    var updateFormData = function (data) {
        form.setFieldsValue(data);
        setNull(data);
    };
    var watchField = function (key, defaultValue) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return Form.useWatch(key, form) || defaultValue;
    };
    useDidMount(function () {
        defaultValue && updateFormData(defaultValue);
    });
    var getFormData = function (key) {
        return form.getFieldValue(key);
    };
    var getAllFormData = function () {
        setNull();
        return form.getFieldsValue();
    };
    var resetFormFields = function () {
        form.resetFields();
    };
    return {
        form: form,
        hasNull: hasNull,
        updateFormData: updateFormData,
        watchField: watchField,
        getFormData: getFormData,
        getAllFormData: getAllFormData,
        resetFormFields: resetFormFields,
    };
};

export { useForm as default };
